import request from './request'

export function getStoreList() {
  return request.get('/Store/list')
}

export function getStoreByInviteCode(inviteCode) {
  return request.post('/Store/getStoreByInviteCode', { invite_code: inviteCode })
}
